const initialState = {
  isLoading: false,
  data: [],
  errorMessage: null,
};

export default function projectsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case "PROJECTS_LOAD_START":
      return {
        ...state,
        isLoading: true,
        data: [],
        errorMessage: null,
      };

    case "PROJECTS_LOAD_SUCCESS":
      return {
        ...state,
        isLoading: false,
        data: payload,
      };

    case "PROJECTS_LOAD_ERROR":
      return {
        ...state,
        isLoading: false,
        errorMessage: payload,
      };

    default:
      return state;
  }
}
